<template>
  <div class="background">
    <div class="chart-container" id="container">
      <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <img src="../../assets/LOGO.png">
        </div>
        <div class="main-header-right">
          <p>{{$t('Segment Analysis Report')}}</p>
          <p style="font-size: 13px;">{{$t('date')}}:{{time}}</p>
        </div>
      </div>
      <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt}">
        <tr>
          <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
          <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
        </tr>
        <tr>
          <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
          <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
        </tr>
        <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
        <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
        <tr>
          <td class="td1 td4">{{$t('disType')}}</td><td colspan="9" class="td4">{{statics.medical_history}}</td>
          <!--<td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>-->
        </tr>
      </table>

      <div class="small-hr"></div>
      <div id="est-a1c">
        <div><span class="est-title">{{$t("est_a1c_t1")}} {{est_a1c}} &nbsp;</span><span>{{$t("est_a1c_t2")}}</span></div>
        <div><span class="x_est-ita">{{$t("est_a1c_t3")}}</span></div>

      </div>
      <img id="img1_1" class="img">
      <table class="sgTable">
        <tr>
          <td class="td2 td5">{{$t('Avg Glucose')}}<br>{{unit}}</td> <td class="td2">{{$t('Below ')}}{{hypo}}{{unit}}</td><td class="td2 td6">{{$t('low')}}</td><td class="td2">{{$t('In Target Range')}}<br>{{target}}</td>
          <td class="td2 td6">{{$t('high')}}</td><td class="td2">{{$t('Coefficient of variation')}} </td><td class="td2 td6">{{$t('SD')}}<br> {{unit}}</td><td class="td3">{{$t('% Time CGM Active')}}</td>
        </tr>
        <tr>
          <td class="td4">{{avg}}</td><td v-for="item in seg" class="td4">{{item}}</td>
          <td class="td4">{{cv}}</td><td class="td4">{{sd}}</td><td>{{active}}</td>
        </tr>
      </table>
      <div class="bolCount">
        <p>{{$t('# of Boluses')}}</p>
        <table class="countLabel">
          <tr id="count">
            <td v-for="i in 48"></td>
          </tr>
        </table>
      </div>
      <img id="img1_3" class="img">
      <img id="img1_2" class="img">
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  export default {
    data() {
      return {
        uid:0, et:0,st:0, time:'',isEn:false,foodCoor:'',unit:'',isMg:'',ts:[],hypo:3.1,high:10.0,low:5.6,isDe:false,isIt:false,
        statics:{},devices:['--','--','--'],hb1c:['--'],target:'',avg:'--',active:'--',seg : ['--','--','--','--'],sd:'--',cv:'--',
        est_a1c:'--'
      }
    },
    methods: {
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/sa',{params:{param}}).then(function (res) {
          let err =res.body.error;
          //console.log(res);
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            if ('EasyPatch'==this.devices[0]) {
              document.getElementById('reportPdmTitle').innerHTML='APP';
            }
            this.hb1c = (data.hba1cList)?data.hba1cList:this.hb1c;
            setTimeout(auth._printPdf(),2000);
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      analySg(){
        let sg = JSON.parse(sessionStorage.getItem('sg7')),validSg =[],totalCount =0,that =this;
        //找出有效sg
        sg.map(function (e,i) {
            let length = e.length;
            if(length>0){
              totalCount += length;
              e.map(function (e1,i1) {
                if(e1[4]==='C'||e1[4]==='NC'){
                  e1[3] = (e1[3]>22.2)?22.2:e1[3];
                  e1[3] = (e1[3]<2.2)?2.2:e1[3];
                  validSg.push(e1[3]);
                }
              })
            }
        });
        let length1 = validSg.length;
        if(totalCount>0&&length1>0){
          let totalSg = 0,Seg=[0,0,0,0];
          let high = (this.isMg)?parseFloat((this.high/18).toFixed(1)):this.high;
          let low = (this.isMg)?parseFloat((this.low/18).toFixed(1)):this.low;
          this.active = ((length1/totalCount)*100).toFixed(1)+' %';
          validSg.map(function (e,i) {
            totalSg +=e;
            if(e<3.1){Seg[0]++;}
            else if(e<low){Seg[1]++;}
            else if(e<high){Seg[2]++;}
            else{Seg[3]++;}
          });
          let avg = totalSg/length1;
          this.avg = (this.isMg)?Math.round(avg*18):avg.toFixed(1);
          this.est_a1c =  (((avg*18)+46.7) / 28.7).toFixed(1) + '%';
          //计算分段比例
          Seg.map(function (e,i) {
            let scale = ((e/length1)*100).toFixed(1);
            that.seg[i] = scale + ' %';
          });
          //计算sd与cv
          let tran = 0;
          validSg.map(function (e,i) {
            let d = e-avg;
            tran +=Math.pow(d,2);
          });
         let sd = Math.sqrt(tran/length1);
         this.sd = (this.isMg)?Math.round(sd*18):sd.toFixed(1);
         this.cv = ((sd/avg)*100).toFixed(1)+' %';
        }
      },
      showCount(){
        let count = JSON.parse(sessionStorage.getItem('count7'));
        let length= count.length;
        let tr = document.getElementById('count');
        for(let i=0;i<length;i++){
          let td = tr.getElementsByTagName('td')[count[i][0]];
          td.innerHTML = count[i][1];
        }
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('Segment Analysis Report');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.unit = (this.isMg)?' mg/dL':' mmol/L';
      this.hypo = (this.isMg)? 54:3.1;
      let st = sessionStorage.getItem('st7');
      let et = sessionStorage.getItem('et7');
      this.st = parseInt(st);
      this.et =  parseInt(et);
      this.ts = [[this.st,this.et]];
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      param = B64.base64encode(JSON.stringify(param));
      this.getStatics(param);
      this.time =sessionStorage.getItem('timeRange7');
      let img1 = document.getElementById('img1_1');
      img1.src = sessionStorage.getItem('src7_1');
      let img2 = document.getElementById('img1_2');
      img2.src = sessionStorage.getItem('src7_2');
      let img3 = document.getElementById('img1_3');
      img3.src = sessionStorage.getItem('src7_3');
      this.high = parseFloat(sessionStorage.getItem('targetH7'));
      this.low = parseFloat(sessionStorage.getItem('targetL7'));
      this.target = '( '+this.low+' - '+this.high+this.unit+' )';
      this.analySg();
      this.showCount();
    },
  }
</script>
<style scoped meadia="print">
  @page{
    size:auto;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    min-height: 307mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    min-height:307mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }


  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  .img{
    width:97%;
    height:160px;
    margin-left: 2%;
    margin-bottom: 10px;
  }

  #est-a1c {
    width:90%;
    margin:15px auto;
  }

  #est-a1c div {
   margin-bottom:5px;
  }

  #est-a1c .x_est-title {
    font-size:14px;
    *font-weight:bold;
  }

  #est-a1c .est-ita {
    font-style:italic;
  }

  .sgTable{
    width: 93%;
    margin:5px auto 20px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    font-size: 13px;
  }
  .sgTable td{
    height:30px;
  }
  .sgTable .td5{
    width: 12%;
  }
  .sgTable .td6{
    width: 10%;
  }

  .bolCount{
    width:90.5%;
    height:30px;
    clear: both;
    margin:0 auto -22px;
  }
  .bolCount p{
    height: 15px;
  }
  .countLabel{
    width: 96.5%;
    height: 15px;
    margin-left: 1.5%;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .countLabel td{
    border:none;
   * border: 1px solid #ccc;
  }
</style>



// WEBPACK FOOTER //
// chart7_print.vue?17e5de19